var map = {
	"./en_US.js": "vy7I",
	"./hi_IN.js": "SolI",
	"./zh_CN.js": "piCw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5SrE";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build821/i18n/langs \.js$
// module id = 5SrE
// module chunks = 74